import { createContext } from "react";
import type { JwtPayload } from "jwt-decode";
import type { UserSystemRoles } from "../../types/enum/user-system-roles.enum";

export interface AuthPayloadDto extends JwtPayload {
  id: string;
  email: string;
  name: string;
  role: UserSystemRoles;
  appName: string;
  tenantEmail: string;
  tenantId: string;
  tokenId?: string;
}

export interface AuthContextData {
  user: AuthPayloadDto;
  token: string;
  isAuthReady?: boolean;
  login: (token: string) => void;
  logout: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextData>(
  {} as AuthContextData,
);
